export enum RedesignButtonIcon {
  NO_ICON = 'no icon',
  ARROW = 'arrow',
  DOWNLOAD = 'download',
  SEARCH = 'search',
  EYE = 'eye',
}
